/** Filter options (aligned with list-asset form values) */
export const ILE_TRANSACTION_TYPES = [
  { value: 'lease', label: 'Lease' },
  { value: 'rent', label: 'Rent' },
  { value: 'sale', label: 'Sale' },
  { value: 'lease_to_own', label: 'Lease to own' },
];

export const ILE_PROPERTY_CATEGORIES = [
  { value: 'office_space', label: 'Office Space' },
  { value: 'warehouse', label: 'Warehouse' },
  { value: 'factory', label: 'Factory' },
  { value: 'industrial_shed', label: 'Industrial Shed' },
  { value: 'retail_shop', label: 'Retail Shop' },
  { value: 'land', label: 'Land' },
  { value: 'cold_storage', label: 'Cold Storage' },
  { value: 'coworking_space', label: 'Coworking Space' },
  { value: 'hospitality_property', label: 'Hospitality Property' },
  { value: 'agricultural_land', label: 'Agricultural Land/Unit' },
];

export const ILE_CITY_SUGGESTIONS = [
  'Mumbai', 'Delhi', 'Bengaluru', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad',
  'Surat', 'Jaipur', 'Lucknow', 'Kochi', 'Indore', 'Nagpur', 'Visakhapatnam',
];

export const ILE_OWNERSHIP_TYPES = [
  { value: 'direct_owner', label: 'Direct Owner' },
  { value: 'broker_agent', label: 'Broker / Agent' },
];

/** Matches `inventoryAvailability.listingAvailabilityState` on published listing cards. */
export const ILE_AVAILABILITY_STATES = [
  { value: 'available', label: 'Available' },
  { value: 'partially_available', label: 'Partially available' },
  { value: 'fully_leased', label: 'Fully leased / Sold out' },
  { value: 'blocked', label: 'Unavailable' },
  { value: 'not_tracked', label: 'Not tracked' },
];

export function normalizeListingOwnershipType(ownershipType) {
  const t = String(ownershipType || '').trim().toLowerCase();
  if (t === 'direct_owner') return 'direct_owner';
  if (t === 'broker_agent' || t === 'broker' || t === 'broker_authorized') return 'broker_agent';
  return 'other';
}

export function listingAvailabilityFilterKey(item) {
  const state = item?.inventoryAvailability?.listingAvailabilityState;
  if (!state || state === 'not_tracked') return 'not_tracked';
  return String(state);
}
